import React from "react";

function plural(n, singular, pluralForma) {
  return `${n} ${n === 1 ? singular : pluralForma}`;
}

/**
 * A prova de que a escala não sobrecarrega ninguém.
 * O total de dias é a parte fácil; o que gera sensação de injustiça são os
 * fins de semana e os feriados, então eles aparecem contados à parte.
 */
export default function Distribuicao({ mes, ano, rotuloMes, anoVisto }) {
  const maxDias = Math.max(...mes.map((p) => p.dias), 1);
  const porId = Object.fromEntries(ano.map((p) => [p.id, p]));

  return (
    <section className="carga" aria-labelledby="carga-titulo">
      <header className="secao__cabecalho">
        <h2 id="carga-titulo">Distribuição</h2>
        <p className="secao__descricao">
          Plantões em {rotuloMes} e o acumulado de {anoVisto}. Na barra, o
          trecho em âmbar é a parte que caiu em fim de semana ou feriado.
        </p>
      </header>

      <ul className="carga__lista">
        {mes.map((p) => {
          const noAno = porId[p.id];
          return (
            <li key={p.id} className="carga__item">
              <img className="avatar avatar--sm" src={p.pessoa.foto} alt="" />

              <span className="carga__nome">{p.pessoa.primeiroNome}</span>

              <span className="carga__total">
                <strong>{p.dias}</strong>
                <span className="carga__unidade">
                  {p.dias === 1 ? "plantão" : "plantões"}
                </span>
              </span>

              <span
                className="carga__barra"
                role="img"
                aria-label={`${plural(
                  p.dias,
                  "plantão",
                  "plantões"
                )} no mês, ${p.pesados} em fim de semana ou feriado`}
              >
                <span
                  className="carga__preenchimento"
                  style={{ width: `${(p.dias / maxDias) * 100}%` }}
                >
                  <span
                    className="carga__pesado"
                    style={{
                      width: `${p.dias ? (p.pesados / p.dias) * 100 : 0}%`,
                    }}
                  />
                </span>
              </span>

              <span className="carga__detalhe">
                {/* Zero não é alerta: só destaca em âmbar o que de fato pesou. */}
                <span className={p.fds ? "carga__pesado-num" : undefined}>
                  {plural(p.fds, "fim de semana", "fins de semana")}
                </span>
                <span className="ponto" aria-hidden="true">
                  ·
                </span>
                <span className={p.feriados ? "carga__pesado-num" : undefined}>
                  {plural(p.feriados, "feriado", "feriados")}
                </span>
                <span className="carga__ano">
                  no ano: {noAno?.dias ?? 0}, sendo {noAno?.pesados ?? 0} em fim
                  de semana ou feriado
                </span>
              </span>
            </li>
          );
        })}
      </ul>

      {/* O rodízio com 7 pessoas é o único caso em que a distribuição deixa de
          circular: cada um passaria a pegar sempre o mesmo dia da semana. É um
          aviso, não uma explicação de rotina — por isso só aparece se acontecer. */}
      {mes.length === 7 && (
        <p className="nota nota--alerta">
          O rodízio está com 7 pessoas, o mesmo tamanho da semana: enquanto ficar
          assim, cada um pega sempre o mesmo dia da semana e os fins de semana
          deixam de circular.
        </p>
      )}
    </section>
  );
}
